module.exports = __webpack_public_path__ + "fonts/AEH.fec4972e.ttf";